import * as React from 'react';
import { useFilterSelectionStore } from 'src/hooks/component/filter_selection';

const FilterSelection = ({ searchOptionModified }) => {
    const [{ filter_list }, { }, { clear_filter_by_key, clear_all_filter }] = useFilterSelectionStore();

    return (
        <>
            {(filter_list && filter_list.length > 0) &&
                <div className="applied-filters-wrapper">
                    <div className="applied-filters border-1">
                        <span className="applied-filters-inner">
                            <div className="filter-controls">
                                <div><strong>Filters</strong></div>
                                <button className="bs5 btn btn-white btn-secondary ms-auto filter-brdcrumb-clear"
                                    data-di-id="di-id-3a31eb8d-378bc1a3"
                                    onClick={() => clear_all_filter()}>
                                    Clear All
                                </button>
                            </div>
                            <div className="filters-breadcrumb">
                                {filter_list.map((v, i) => (
                                    <div key={i} className="filter-group">
                                        <div name="categoryId" className="filter-group-title">
                                            <span tabIndex={"-1"}
                                                className="filter-name noSelect">{searchOptionModified ? searchOptionModified[v.searchType] : v.searchType}</span>
                                            <button className="remove-filter-group" name="categoryId"
                                                onClick={() => clear_filter_by_key(i)}><i
                                                    className="fa fa-times"></i><span className="sr-only">Remove
                                                        Filter</span></button>
                                        </div>
                                        <div className="group-filters">
                                            <div className="group-filter-item">
                                                {v.searchKeyword ?
                                                    <span className="button-white button-small"><span
                                                        tabIndex={"-1"} className="filter-item">
                                                        {v.searchKeyword}</span>
                                                        <a href={void (0)} onClick={() => clear_filter_by_key(i)}><i
                                                            className="fa fa-times"></i><span className="sr-only">Remove
                                                                Filter</span></a>
                                                    </span>
                                                    : <>
                                                        {v.searchKeywordArr && v.searchKeywordArr?.length > 0 &&
                                                            v.searchKeywordArr.map((ele) => (
                                                                <span className="button-white button-small"
                                                                    key={ele}><span tabIndex={"-1"}
                                                                        className="filter-item">
                                                                        {ele}</span>
                                                                </span>
                                                            ))
                                                        }
                                                    </>
                                                }

                                            </div>
                                        </div>
                                    </div>
                                ))
                                }
                            </div>
                        </span>
                    </div>
                </div>
            }
        </>
    );
}

export default FilterSelection;